import { Path } from '@/types/global';
import { OverrideLogicFormFields } from './types';

export const path = (path: Path<OverrideLogicFormFields>) => path;
